import { createSlice } from "@reduxjs/toolkit";
import { getPatientDetails } from "../../reducer/getPatientDetails/getPatientDetailsReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const getPatientDetailsSlice = createSlice({
  name: "getPatientDetails",
  initialState,
  reducers: {
    resetPatientDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPatientDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPatientDetails } = getPatientDetailsSlice.actions;

export default getPatientDetailsSlice.reducer;
